<div class="page-title">Password Reset</div>
<div class="page-sub-title">You have successfully reset your password</div>

<div class="col-lg-6 col-md-8 col-sm-10 col-lg-offset-3 col-md-offset-2 col-sm-offset-1 push-up-50">
  <div class="panel-auth">
    <img class="title-img" src="/images/veri-b.jpg" />

    <div class="col-md-10 col-sm-12 col-md-offset-1 col-sm-offset-0">
      <div class="col-md-12 col-sm-12">

        <h5 class="panel-title push-down-30">Password Reset Successfully</h5>

        <div class="push-up-30">
          <div class="profile-sec-wrap">
            You have successfully reset your MindBerry account password. You can now continue to your account as usual.
          </div>
        </div>

        <div class="col-sm-8 col-sm-offset-2 push-down-10 push-up-30">
          <a class="btn-main-proceed-alt" routerLink="/login">My Account</a>
        </div>

        <div class="clear"></div>
      </div>
    </div>

    <div class="clear"></div>
  </div>
</div>
